/* eslint-disable react/function-component-definition */
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { useAtom } from 'jotai';
import { bootstrapInfos } from 'store/public/bootstrapInfo';

export default function HeaderLogo() {
  const [getBootstrapInfos] = useAtom(bootstrapInfos);

  return (
    <Container>
      <LogoContainer>
        <Box
          component="img"
          // src={LOGO_ORANGE}
          src={`${getBootstrapInfos?.['server-download']}/Downloader/Process?Key=${getBootstrapInfos?.['logo-tempalate']}`}
          sx={{
            // width: '102.97px',
            height: '34px',
          }}
        />
      </LogoContainer>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  width: 340px;
  display: flex;
  justify-content: center;
  ${({ theme }) => ({
    [theme.breakpoints.down('lg')]: {
      width: '280px',
    },
  })}
`;

const LogoContainer = styled.div`
  position: relative;
  width: 310px;
  height: 45px;
  display: flex;
  align-items: center;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  justify-content: center;
  background-image: linear-gradient(90deg, #010f19, #063c66, #010f19);
  &:before,
  &:after {
    content: '';
    position: absolute;
    //background-color: #010f19;
    top: 0;
    border: solid #010f19;
    border-left-color: rgba(1, 15, 25, 0.2);
    border-bottom-color: rgba(1, 15, 25, 0.2);
    border-width: 20px 13px 20px 8px;
  }
  &:after {
    left: -8px;
    transform: rotateY(180deg) skew(-30deg);
  }
  &:before {
    right: -8px;
    transform: skew(-30deg);
  }
  ${({ theme }) => ({
    [theme.breakpoints.down('lg')]: {
      width: '251px',
    },
  })}
`;
